"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayOrderWithCardResponseMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class PayOrderWithCardResponseMapper {
    toDomain(result) {
        const method = lodash_1.default.get(result, 'data.payOrderWithCard.method');
        const uri = lodash_1.default.get(result, 'data.payOrderWithCard.uri');
        const body = lodash_1.default.get(result, 'data.payOrderWithCard.body');
        return {
            method,
            uri,
            body,
        };
    }
}
exports.PayOrderWithCardResponseMapper = PayOrderWithCardResponseMapper;
